import { Card } from "../../ui-library/Card/Card.tsx";
import { Skeleton } from "../../ui-library/Skeleton/Skeleton.tsx";

export const LoadingCard = () => (
  <Card>
    Starting content synthesis & curation... this might take up to several
    minutes. Please check back shortly to see how things are progressing. Thank
    you for your patience!
    <p />
    <Skeleton width={100} />
    <Skeleton width={70} />
    <Skeleton width={50} />
    <Skeleton width={100} />
    <Skeleton width={30} />
    <p />
    <Skeleton width={100} />
    <Skeleton width={100} />
    <Skeleton width={20} />
  </Card>
);
